import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Reveal from '@/components/base/Reveal';
import { SITE } from '@/constants/site';

export default function CtaSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-50 px-4 py-16 md:px-6 md:py-24">
      <Reveal className="mx-auto w-full max-w-content">
        <div className="relative overflow-hidden rounded-lg bg-primary-500 px-6 py-12 md:px-14 md:py-16">
          <div
            className="pointer-events-none absolute inset-0 opacity-10"
            style={{
              backgroundImage:
                'linear-gradient(oklch(var(--foreground-950)) 1px, transparent 1px), linear-gradient(90deg, oklch(var(--foreground-950)) 1px, transparent 1px)',
              backgroundSize: '48px 48px',
            }}
          />
          <div className="pointer-events-none absolute -right-16 -top-16 h-64 w-64 rounded-full bg-background-50/15 blur-2xl" />
          <div className="relative flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between">
            <div className="max-w-2xl">
              <h2 className="font-heading text-2xl font-bold leading-tight text-background-50 md:text-4xl">
                {t('home.cta.title')}
              </h2>
              <p className="mt-4 text-base leading-relaxed text-background-100">{t('home.cta.subtitle')}</p>
            </div>
            <div className="flex flex-none flex-col gap-3 sm:flex-row">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors duration-200 hover:bg-foreground-800"
              >
                {t('home.cta.primary')}
                <i className="ri-arrow-right-line text-base" />
              </Link>
              <a
                href={SITE.emailHref}
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors duration-200 hover:bg-background-50/10"
              >
                <i className="ri-mail-line text-base" />
                {t('home.cta.secondary')}
              </a>
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
}